import { render, staticRenderFns } from "./OverviewTitle.vue?vue&type=template&id=6ca244ec&scoped=true"
import script from "./OverviewTitle.vue?vue&type=script&lang=js"
export * from "./OverviewTitle.vue?vue&type=script&lang=js"
import style0 from "./OverviewTitle.vue?vue&type=style&index=0&id=6ca244ec&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca244ec",
  null
  
)

export default component.exports